export const MAX_UPLOAD_SIZE_MB = 10;
export const MAX_UPLOAD_SIZE_BYTES = MAX_UPLOAD_SIZE_MB * 1024 * 1024;
export const UPLOAD_SIZE_ERROR =
  'Ce fichier dépasse la limite de 10 Mo. Réduisez sa taille avant de réessayer.';

export const getUploadError = error => {
  const errors = error?.response?.data?.errors;
  if (typeof errors === 'string') return errors;
  const messages =
    errors &&
    Object.values(errors)
      .flat()
      .filter(value => typeof value === 'string');
  return messages?.join(' ') || 'Le document n’a pas pu être envoyé.';
};
